import { Link } from '@primer/components';
import shared from "../../../../src/shared.js";
import * as React from 'react';
export default {
  Link,
  shared,
  React
};